import { Box, Typography } from '@mui/material';
import { AppBar, TitlePortal } from 'react-admin';

/**
 * The blue bar, with the shop's mark on it.
 *
 * Two admins for two shops look identical without it, and this one is often
 * open beside the storefront - the logo is what tells the tabs apart at a
 * glance.
 *
 * The image is served from the app itself rather than the CDN: it is part of
 * the shell, and a logo that waits on a third-party request is the one thing
 * on screen that flickers on every page load.
 */
export function AdminAppBar() {
  return (
    <AppBar>
      <Box
        component="img"
        src="/logo-icon.png"
        alt=""
        sx={{ height: 28, width: 28, mr: 1.5, borderRadius: 0.5, bgcolor: 'common.white', p: 0.25 }}
      />
      <Typography variant="h6" color="inherit" sx={{ mr: 2, fontWeight: 600 }}>
        Clean Tonery
      </Typography>

      {/* Where react-admin puts each screen's own title. */}
      <TitlePortal />
    </AppBar>
  );
}
